<template>
  <Modal
    class="max-modal detail-modal"
    :mask-closable="false"
    :closable="false"
    title="订单详情"
    v-model="modal">
    <div class="box-detail">
      <div class="box-detail__img">
        <img :src="detail.imageBase64" alt="">
      </div>
      <div class="box-detail__info">
        <h3>
          {{ detail.commodityName }}
          <RechargeStatus :node-state="detail.nodeState" />
        </h3>
        <ul>
          <li><span>订单编号：</span><p>{{ detail.outTradeNo }}</p></li>
          <li><span>创建时间：</span><p>{{ detail.createDateStr}}</p></li>
          <li class="hr"></li>
          <li><span>商品编号：</span><p>{{ detail.commodityNo }}</p></li>
          <li><span>商品名称：</span><p>{{ detail.commodityName }}</p></li>
          <li class="hr"></li>
          <li><span>充值账号：</span><p>{{ detail.account }}</p></li>
          <li><span>充值方式：</span><p>{{ rechargeMethodLabel }}</p></li>
          <li><span>充值状态：</span><p>{{ rechargeStatusLabel }}</p></li>
          <li class="hr"></li>
          <li><span>代理商编号：</span><p>{{ detail.agentId }}</p></li>
          <li><span>代理商名称：</span><p>{{ detail.agentName }}</p></li>
        </ul>
      </div>
    </div>
    <div slot="footer">
      <Button type="primary" @click="hide">关闭</Button>
    </div>
  </Modal>
</template>

<script>
import DefaultImage from '../../assets/img/commodity-image.png'
import RechargeStatus from '../../components/order/RechargeStatus'

export default {
  name: 'CommodityDetail',
  components: {
    RechargeStatus
  },
  data () {
    return {
      modal: false,
      detail: {}
    }
  },
  computed: {
    rechargeMethodLabel () {
      const item = this.$store.getters['recharge/rechargeMethodByValue'](this.detail.rechargeType)
      return item ? item.label : '---'
    },
    rechargeStatusLabel () {
      const item = this.$store.getters['recharge/rechargeStatusByValue'](this.detail.nodeState)
      return item ? item.label : '---'
    }
  },
  methods: {
    show (data = {}) {
      data.imageBase64 = data.imageBase64 || DefaultImage
      this.detail = data
      this.modal = true
    },
    hide () {
      this.modal = false
    }
  }
}
</script>
